"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var FormatAlignCenter_exports = {};
__export(FormatAlignCenter_exports, {
  default: () => FormatAlignCenter_default
});
module.exports = __toCommonJS(FormatAlignCenter_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.3398 15.25C16.5612 15.25 16.75 15.3346 16.9062 15.5039C17.0755 15.6602 17.1602 15.8555 17.1602 16.0898C17.1602 16.3112 17.0755 16.5065 16.9062 16.6758C16.75 16.832 16.5612 16.9102 16.3398 16.9102H4.66016C4.4388 16.9102 4.24349 16.832 4.07422 16.6758C3.91797 16.5065 3.83984 16.3112 3.83984 16.0898C3.83984 15.8555 3.91797 15.6602 4.07422 15.5039C4.24349 15.3346 4.4388 15.25 4.66016 15.25H16.3398ZM13.8398 9.41016C14.0612 9.41016 14.25 9.49479 14.4062 9.66406C14.5755 9.82031 14.6602 10.0156 14.6602 10.25C14.6602 10.4844 14.5755 10.6862 14.4062 10.8555C14.25 11.0117 14.0612 11.0898 13.8398 11.0898H7.16016C6.9388 11.0898 6.74349 11.0117 6.57422 10.8555C6.41797 10.6862 6.33984 10.4844 6.33984 10.25C6.33984 10.0156 6.41797 9.82031 6.57422 9.66406C6.74349 9.49479 6.9388 9.41016 7.16016 9.41016H13.8398ZM18 3.58984C18.2344 3.58984 18.4297 3.67448 18.5859 3.84375C18.7552 4 18.8398 4.1888 18.8398 4.41016C18.8398 4.64453 18.7552 4.84635 18.5859 5.01562C18.4297 5.17188 18.2344 5.25 18 5.25H3C2.76562 5.25 2.5638 5.17188 2.39453 5.01562C2.23828 4.84635 2.16016 4.64453 2.16016 4.41016C2.16016 4.1888 2.23828 4 2.39453 3.84375C2.5638 3.67448 2.76562 3.58984 3 3.58984H18Z",
      fill: "currentColor"
    }
  )
);
const SvgFormatAlignCenter = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var FormatAlignCenter_default = SvgFormatAlignCenter;
